import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getMe } from "../../api/auth";
import type { Me } from "../../api/auth";
import { ApiError } from "../../api/client";

export const ME_KEY = ["me"] as const;

/** The logged-in student, `null` when there is no session. */
export function useMe() {
  return useQuery<Me | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await getMe();
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}

/** After login/registration: reload `/me` so guarded routes see the new session. */
export function useRefreshSession() {
  const client = useQueryClient();
  // Also refetch when no component watches `/me` right now (e.g. on the login page).
  return () => client.invalidateQueries({ queryKey: ME_KEY, refetchType: "all" });
}
